import { memo } from "react";
import { Outlet } from "react-router-dom";
import { ConversationFiltersProvider } from "./filters/filters-context";
import {
  SupportProviders,
  useFeatureFlagEnabled,
} from "./providers/support-providers";

const SupportHelpdeskContent = memo(function SupportHelpdeskContent() {
  const featureFlagEnabled = useFeatureFlagEnabled();

  if (!featureFlagEnabled) {
    return <div>Support Helpdesk V2 is not enabled</div>;
  }

  return <Outlet />;
});

/**
 * Layout component for Support Helpdesk that provides shared context
 * (collections, feature flags) across all support-v2 routes.
 * This ensures TanStack DB collections persist across navigation.
 */
export const SupportHelpdesk = memo(function SupportHelpdesk() {
  return (
    <SupportProviders>
      <ConversationFiltersProvider>
        <SupportHelpdeskContent />
      </ConversationFiltersProvider>
    </SupportProviders>
  );
});
